<template>
  <v-form v-model="valid" ref="form">
    <v-card color="#284e3c" class="white--text">
      <v-divider class="mx-2" inset horizontal></v-divider>
        <v-card-title>
          <v-icon color="white" large left>vpn_key</v-icon>
          <span class="title font-weight-heavy"> Changing Password for '{{ user.username }}'
                <button type="button" class="btn btn-secondary" data-toggle="tooltip" data-placement="left" title="Please enter old password, then enter new password and confirm it.">
                <v-icon color="white" large right>help_outline</v-icon>
            </button>
          </span>
        </v-card-title>
        <v-card-title>
          <span><v-text-field v-if="OldPasswordShow === true" v-model="OldPassword" :rules="rules.old" class="title font-weight-heavy" type='Password' color= 'white' label='Old Password:'></v-text-field></span>
          <span><v-divider class="mx-12" inset horizontal></v-divider></span>
        </v-card-title>
        <v-card-title>
          <span><v-text-field v-model="NewPassword" :rules="rules.new" class="title font-weight-heavy" type='Password' color='white' label='New Password' autocomplete="new-password"></v-text-field></span>
          <span><v-divider class="mx-12" inset horizontal></v-divider></span>
          <span><v-text-field v-model="ConfirmPassword" :rules="rules.confirm" class="title font-weight-heavy" type='Password' color='white' label='Confirm Password' autocomplete="new-password"></v-text-field></span>
        </v-card-title>
        <v-card-title>
          <span><v-divider class="mx-12" inset horizontal></v-divider></span>
          <span><v-divider class="mx-12" inset horizontal></v-divider></span>
          <span><v-divider class="mx-12" inset horizontal></v-divider></span>
          <span><v-divider class="mx-12" inset horizontal></v-divider></span>
          <span><v-divider class="mx-12" inset horizontal></v-divider></span>
          <span><v-divider class="mx-12" inset horizontal></v-divider></span>
          <span><v-divider class="mx-12" inset horizontal></v-divider></span>
          <span><v-divider class="mx-12" inset horizontal></v-divider></span>
          <span>
          <v-btn name="SaveChangesBtn" v-on:click="SaveChanges" :disabled="!valid" color="info">Save Changes</v-btn>
          <v-btn name="CancelChangesBtn" v-on:click="CancelChanges" color="warning" type="submit">Cancel Changes</v-btn>
          </span>
        </v-card-title>
        <v-divider class="mx-2" inset horizontal></v-divider>
    </v-card>
  </v-form>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    rules () {
      const valid = (this.NewPassword === this.ConfirmPassword)
      return {
        old: [
          (v) => !!v || 'Password can not be empty.'
        ],
        new: [
          (v) => !!v || 'Password can not be empty.',
          (v) => !!(v.length >= 8) || 'Password must be greater than 8 characters.'
        ],
        confirm: [
          (v) => !!v || 'Password can not be empty.',
          (v) => valid || 'Confirm and New passwords do not match!'
        ]
      }
    },
    ...mapGetters({ currentUser: 'currentUser' })
  },
  name: 'ChangePassword',
  props: {
    userID: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    user: {
      username: '',
      sms: '',
      email: ''
    },
    error: '',
    valid: false,
    OldPasswordShow: false,
    OldPassword: '',
    NewPassword: '',
    ConfirmPassword: ''
  }),
  methods: {
    CancelChanges () { // reloads page and cancels all changes
      this.$router.go()
    },
    UserValidQ () {
      // Validate current logged in user password
      this.$http.post('/user/tokens', {}, { auth: { username: this.user.username, password: this.OldPassword } })
        .then(request => this.OldPasswordCheckSuccessful(request))
        .catch(error => this.OldPasswordCheckFailed(error))
    },
    OldPasswordCheckSuccessful (request) {
      // Current logged in user password is correct
      // ..ensure a valid token was returned.
      if (!request.data.token || request.data.error) {
        this.OldPasswordCheckFailed('invalid token')
        return
      }
      // alert('Old Password Is Correct')
      this.postPWChanges()
    },
    OldPasswordCheckFailed (error) {
      alert('CurrentUser - Old Password Incorrect')
      // eslint-disable-next-line
      console.log(error)
    },
    SaveChanges () {
      // If changing password for current logged in user
      if (this.OldPasswordShow) {
        // Confirm current logged in user
        this.UserValidQ()
      } else {
        // Reset password for selected user
        this.postPWChanges()
      }
    },
    postPWChanges () {
      var url = `/schemas/users/${this.userID}`
      this.$http
        .put(url,
          {
            'password': `${this.NewPassword}`
          }
        )
        .then(response => {
          this.UserPWUpdated(response.data.user)
        })
        .catch(error => this.putUserRequestFailed(error))
    },
    UserPWUpdated (user) {
      // eslint-disable-next-line no-console
      // console.log(`Updated User: ${user.username}`)
      this.$router.go()
    },
    putUserRequestFailed (error) {
      this.error = 'Failed to update user data'
      // eslint-disable-next-line
      console.log(error)
      this.$parent.$emit('error', this.error)
    },
    getUserDetails () {
      var url = `/schemas/users/${this.userID}`
      // Get User information
      this.$http
        .get(url)
        .then(response => {
          this.setUserForm(response.data.user)
        })
        .catch(error => this.getUserRequestFailed(error))
    },
    setUserForm (user) {
      this.user = user
      this.OldPasswordShow = (this.currentUser.username === user.username)
    },
    getUserRequestFailed (error) {
      this.error = 'Failed to retrieve user data'
      // eslint-disable-next-line
      console.log(error)
      this.$parent.$emit('error', this.error)
    }
  },
  beforeMount () {
    this.getUserDetails()
  }
}
</script>
